export default {
    getUploadProgress: (state) => state.uploadProgress, 
    getTempDocs: (state) => state.tempDocs,
    getButtons: (state) => state.buttons,
    getGeneralInfo: (state) => state.generalInfo,
  };
  